import Splide from "@splidejs/splide";

async function init() {
  const sliders = document.querySelectorAll(
    ".js-video-carousel"
  ) as NodeListOf<HTMLElement>;

  if (sliders.length === 0) return;

  const { Video } = await import("@splidejs/splide-extension-video");

  for (const slider of sliders) {
    const splide = new Splide(slider, {
      perPage: 4,
      arrows: true,
      pagination: false,
      width: "100%",
      gap: "var(--column-gap)",
      breakpoints: {
        768: {
          arrows: false,
          pagination: true,
          perPage: 1,
          fixedWidth: "60%",
          gap: "var(--column-gap)",
        },
      },
    });
    splide.mount({ Video });
  }
}

export default init;
